import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { Link } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import WarningNoticeBanner from '../../../components/designe/warning-notice-banner/WarningNoticeBanner';
import { useRegisterPageContainerError } from '../../../components/layout/page-container/page-container-error-handler';
import withRouter from '../../../hoc/with-router';
import { useGetAvailableUserProgramItems } from '../../../redux/api/programsAPI';
import { useGetUserTrainingAccessOutgoing } from '../../../redux/api/userTrainingAccessApi';
import { Paths } from '../../../shared/paths';
import ProgramItemsList from '../shared/program-items-list/ProgramItemsList';
import { useStyles } from './AvailableProgramItems.styles';

function AvailableProgramItems() {
  const { t } = useTranslation();
  const {
    data: availableProgramItems,
    isFetching,
    isLoading,
    error,
    refetch,
  } = useGetAvailableUserProgramItems();
  const {
    data: accessData,
    isLoading: isAccessLoading,
    isFetching: isAccessFetching,
  } = useGetUserTrainingAccessOutgoing();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const isDataLoading =
    isLoading || isFetching || isAccessLoading || isAccessFetching;
  const showAccessWarning =
    !isDataLoading &&
    !!availableProgramItems &&
    availableProgramItems.length === 0 &&
    (accessData?.sharePrograms?.length ?? 0) === 0;
  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);
  useRegisterPageContainerError({
    errors: error ? [error] : [],
    isLoading: isDataLoading,
    hasData: Boolean(availableProgramItems?.length),
    onRetry: handleRetry,
  });

  return (
    <ProgramItemsList
      programItems={availableProgramItems}
      isLoading={isDataLoading}
      listKind="available"
      emptyStateBanner={
        showAccessWarning ? (
          <WarningNoticeBanner title={t('programs.availableEmptyBannerTitle')}>
            <Trans
              i18nKey="programs.availableEmptyBannerDescription"
              components={[
                <Link
                  key="access-link"
                  component={RouterLink}
                  to={Paths.settings.toAccess}
                />,
              ]}
            />
          </WarningNoticeBanner>
        ) : null
      }
    />
  );
}

export default withRouter(AvailableProgramItems);
